import { Slider } from '../../slider';

export class GroupSlider extends Slider {}
